import { Card } from "antd";
import { useEffect } from "react";
import api from "../api/axios";
import Chatbot from "../components/Chatbot";
import { useView } from "../contexts/ViewContext";
import cardStyle from "./Card.module.css"

function Interview({ learningJourneyId, view }) {
    const { setOnAdvance } = useView();

    useEffect(() => {
        const viewId = view.view_id;
        setOnAdvance(async () => {
            try {
                await api.post(`/workspace/interview/advance/`, {
                    learning_journey_id: learningJourneyId,
                    view_id: viewId,
                });
            } catch (error) {
                console.error("Failed to advance the interview:", error);
            }
        });
    }, [view.view_id, learningJourneyId, setOnAdvance]);

    // Unregister on unmount so a later, unrelated view's "Continue" click
    // can never fire this interview's advance call.
    useEffect(() => () => setOnAdvance(null), [setOnAdvance]);

    return (
        <Card
            variant="borderless"
            className={cardStyle.cardContainer}
            styles={{
                body: {
                    height: "100%",
                    padding: 0,
                    display: "flex",
                },
            }}
        >
            <Chatbot
                learningJourneyId={learningJourneyId}
                view={view}
                emptyStateText={view?.view_data?.empty_state_text}
            />
        </Card>
    );
}

export default Interview;
